const carouselItems = [
  {
    tag: '娱乐圈',
    title: '当红明星恋情实锤全记录',
    desc: '近期多对明星恋情接连曝光，从机场同框到深夜聚餐，细节全盘点，带你看懂娱乐圈恋爱新格局。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photography%20style%20image%20with%20soft%20glamorous%20atmosphere%2C%20romantic%20evening%20cityscape%20with%20bokeh%20lights%2C%20elegant%20silhouettes%20in%20warm%20golden%20lighting%2C%20magazine%20cover%20aesthetic%20with%20crimson%20accent%20highlights%2C%20cinematic%20mood%20with%20dreamy%20atmosphere%2C%20clean%20minimal%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    date: '2026-07-28',
    views: '128万',
  },
  {
    tag: '综艺',
    title: '热门综艺幕后爆料大合集',
    desc: '多档热门综艺录制现场爆料流出，赛制争议、选手关系、导师内幕，吃瓜第一手资料独家整理。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20lighting%20with%20warm%20golden%20and%20crimson%20spotlights%2C%20abstract%20talent%20show%20atmosphere%2C%20dramatic%20theatrical%20composition%20with%20soft%20glow%20effects%2C%20modern%20entertainment%20production%20aesthetic%2C%20clean%20professional%20stage%20design%20background%2C%20warm%20ambient%20tones&width=800&height=500&seq=carousel-02&orientation=landscape',
    date: '2026-07-27',
    views: '96万',
  },
  {
    tag: '网红',
    title: '头部网红翻车事件深度复盘',
    desc: '从千万粉丝到人设崩塌，多位头部网红近期争议事件完整时间线梳理，还原事件真相与背后逻辑。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20illustration%20with%20dramatic%20warm%20crimson%20and%20amber%20color%20palette%2C%20fragmented%20social%20media%20icons%20floating%20in%20dynamic%20composition%2C%20modern%20editorial%20design%20with%20layered%20transparent%20elements%2C%20atmospheric%20dramatic%20lighting%2C%20clean%20minimal%20aesthetic%20with%20strong%20visual%20impact&width=800&height=500&seq=carousel-03&orientation=landscape',
    date: '2026-07-26',
    views: '215万',
  },
  {
    tag: '影视',
    title: '暑期档票房大战暗流涌动',
    desc: '暑期档多部大片正面交锋，票房数据争议不断，排片潜规则与院线博弈内幕全方位揭秘。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20projector%20abstract%20composition%20with%20warm%20golden%20amber%20light%20rays%2C%20movie%20theater%20atmosphere%20with%20soft%20dramatic%20lighting%2C%20modern%20entertainment%20industry%20aesthetic%2C%20clean%20professional%20photography%20style%2C%20rich%20warm%20color%20palette%20with%20crimson%20highlights&width=800&height=500&seq=carousel-04&orientation=landscape',
    date: '2026-07-25',
    views: '87万',
  },
  {
    tag: '热点',
    title: '社会热议事件各方回应汇总',
    desc: '近期多个社会热点事件持续发酵，涉事各方最新回应与动态全追踪，为你呈现事件完整面貌。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20newsroom%20inspired%20abstract%20composition%20with%20warm%20crimson%20and%20golden%20tones%2C%20overlapping%20geometric%20shapes%20representing%20headlines%20and%20breaking%20news%2C%20dynamic%20typography%20elements%20in%20editorial%20layout%2C%20clean%20minimal%20design%20with%20atmospheric%20depth%2C%20professional%20journalism%20aesthetic&width=800&height=500&seq=carousel-05&orientation=landscape',
    date: '2026-07-24',
    views: '302万',
  },
  {
    tag: '国际',
    title: '国际娱乐大事件年度盘点',
    desc: '好莱坞风云变幻、韩流新格局、欧美乐坛地震，国际娱乐板块今年最值得关注的十大事件深度盘点。',
    img: 'https://readdy.ai/api/search-image?query=Global%20entertainment%20collage%20with%20world%20map%20texture%20and%20warm%20golden%20amber%20gradient%2C%20international%20landmarks%20silhouettes%20blended%20with%20dynamic%20light%20streaks%2C%20modern%20editorial%20magazine%20design%20aesthetic%2C%20rich%20crimson%20accent%20highlights%2C%20clean%20professional%20composition%2C%20atmospheric%20global%20perspective&width=800&height=500&seq=carousel-06&orientation=landscape',
    date: '2026-07-23',
    views: '76万',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            全网热议的吃瓜大事件专题追踪，深度还原事件全貌
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500/85 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}